module.exports = __webpack_public_path__ + "static/img/playMediaIcon.be51e797.png";